import React, { useContext } from 'react';
import tw from 'twin.macro';
import { PreferenceContext } from '../context';

export const Wrapper = ({ WrapperType, children, maxNumItems, ...restProps }) => {
  if (WrapperType) {
    return (
      <WrapperType maxNumItems={maxNumItems} {...restProps}>
        {children}
      </WrapperType>
    );
  }
  if (!WrapperType) {
    return <>{children}</>;
  }
};

export const AppWrapper = ({ children }) => {
  const {
    preference: { theme },
  } = useContext(PreferenceContext);
  const isLightTheme = theme === 'light';
  return (
    <div
      css={[
        tw`bg-primary min-w-[340px] text-default w-full transition-all duration-200 leading-relaxed`,
        isLightTheme && tw`font-medium`,
      ]}
    >
      {children}
    </div>
  );
};
